import type { InsertDataImportMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { InsertDataImportDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

export const useInsertDataImport = createMutationHook({
  name: 'insertDataImport',
  isIdempotentCreate: true,
  mutationOptions: (trpc, onSuccess, requestContext) =>
    trpc.frontend.dataImport.insertDataImport.mutationOptions({
      onSuccess,
      trpc: { context: requestContext },
    }),
  mapInput: (_input: void) => undefined,
  invalidate: (trpc) => [trpc.frontend.dataImport.dataImports.queryKey()],
  mapResponse: (result: { Id: string }): InsertDataImportMutation => ({
    insert_data_import_one: {
      __typename: 'data_import',
      Id: result.Id,
    },
  }),
  graphqlDocument: InsertDataImportDocument,
  graphqlVariables: () => ({}),
  evictFields: ['data_import'],
});
